/* eslint-disable */
import React from 'react'
const CalendarIcon = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 49 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.7917 8.16663H10.2083C7.95317 8.16663 6.125 9.9948 6.125 12.25V40.8333C6.125 43.0885 7.95317 44.9166 10.2083 44.9166H38.7917C41.0468 44.9166 42.875 43.0885 42.875 40.8333V12.25C42.875 9.9948 41.0468 8.16663 38.7917 8.16663Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.6665 4.08337V12.25"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3335 4.08337V12.25"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.125 20.4166H42.875"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.4557 35.7021L31.8365 26.3092L33.1632 27.6342L22.4566 38.3546L16.8369 32.735L18.1627 31.4091L22.4557 35.7021Z"
      fill="white"
    />
  </svg>
)

CalendarIcon.defaultProps = {
  width: 49,
  height: 49,
}

export default CalendarIcon
